import { MetaModelViewGraphNode } from '@ardoq/graph';
import { getId } from '../getId';
import { TraversalBuilderState } from '../types';
import { getComponentTypeDisplayLabel } from './getComponentTypeDisplayLabel';

type CreateStartNodeParams = {
  startType: string | null;
  traversalStartSet: string[];
  traversalStartQueryResultCount: number | undefined;
  rawGraphNodes: TraversalBuilderState['rawGraphNodes'];
  isHierarchyWildcardActive: boolean;
};

export const createStartNode = ({
  startType,
  traversalStartSet,
  traversalStartQueryResultCount,
  rawGraphNodes,
  isHierarchyWildcardActive,
}: CreateStartNodeParams): {
  startNode: MetaModelViewGraphNode | null;
  counts: number | undefined;
} => {
  if (!startType) {
    return { startNode: null, counts: undefined };
  }

  const rawStartGraphNode = rawGraphNodes.get(startType);
  if (!rawStartGraphNode) {
    return { startNode: null, counts: undefined };
  }

  const { metaData } = rawStartGraphNode;
  const counts =
    traversalStartSet.length > 0
      ? traversalStartSet.length
      : (traversalStartQueryResultCount ?? undefined);
  // Keep `metaData.label` as-is (it is what serialises to the backend); only
  // the displayed label gets the friendly wildcard name. When there is no count
  // we still surface the display label for the wildcard node (its raw
  // `metaData.label` would otherwise show through `getLabelWithCount`'s
  // fallback); concrete types keep the existing empty-string behaviour.
  const displayLabel = getComponentTypeDisplayLabel(
    metaData.label,
    isHierarchyWildcardActive
  );
  const labelWithCount =
    counts !== undefined
      ? `${displayLabel} (${counts})`
      : displayLabel === metaData.label
        ? ''
        : displayLabel;
  const startNode = MetaModelViewGraphNode.create(startType, getId(), {
    ...metaData,
    isContext: true,
    shouldDisplayClickOtherComponentsHint: false,
    labelWithCount,
  });
  startNode.setIsSelected(true);
  return { startNode, counts };
};
